import Location from '../../../hooks/Location.js'
import HouseholdMaterialsSection from './HouseholdMaterialsSection'

// AI-CONTEXT: See docs/patterns.md#ui-adress-tab
// AI-CONTEXT: See docs/features/household-materials.md

const Materialen = ({ adressNavigation }) => {
    const adressID = Location()[3]

    return (
        <div style={{ display: adressNavigation === 'materials' ? 'block' : 'none' }}>
            <div className='persona-option-container'>
                <HouseholdMaterialsSection adressID={adressID} />
            </div>
        </div>
    )
}

export default Materialen
